module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAADAgMAAABZiT+aAAAACVBMVEVTU1MMs/Uvg6RiMWryAAAAEUlEQVQI12MIBYIEBgQgLAAAnlUFHTfpvk8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/border-bg.png
// module id = 380
// module chunks = 0